"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducers = void 0;
var reducers = exports.reducers = {
  baseUrl: function baseUrl() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return state;
  }
};